import request from '@/utils/request'

// 获取保司列表
export const getCompany = () => {
  return request.post(`/story/file/companies`)
}
// 文件知识拆分知识块
export const fileSplit = (params) => {
  return request.post(`/knowdocSlice/split`, params)
}
// 获取文件上传地址
export const getUploadUrl = (params) => {
  return request.post(`/file/uploadUrl`, params)
}
// 获取文件预览URL
export const getFileUrl = (params) => {
  return request.post(`/file/getUrl`, params)
}
// 保存课程
export const courseAdd = (params) => {
  return request.post(`/course/add`, params)
}
// 修改课程
export const courseUpd = (params) => {
  return request.post(`/course/upd`, params)
}
// 查询课程列表
export const courseList = (params) => {
  return request.post(`/course/list`, params)
}
// 保存文件
export const fileAdd = (params) => {
  return request.post(`/knowdoc/add`, params)
}
// 获取外接知识库
export const getKnowledge = () => {
  return request.post(`/story/file/knowledge/list`)
}
// 获取外接知识库详情
export const getKnowledgeDetail = (params) => {
  return request.post(`/story/file/knowledge/split/${params.id}`)
}
// 保存
export const knowledgeSave = (params) => {
  return request.post(`/story/file/save`, params)
}
// --------------------------------
// taskBaseList
export const taskBaseList = (params) => {
  return request.post(`/source/task/page`, params)
}
// 查询文件列表（根据courseId）
export const fileList = (params) => {
  return request.post(`/knowdoc/list`, params)
}
// 查询知识块列表（根据docId）
export const knowdocSliceList = (params) => {
  return request.post(`/knowdocSlice/list`, params)
}
// 批量更新知识块切片内容
export const knowdocSliceBatchUpd = (params) => {
  return request.post(`/knowdocSlice/batchUpd`, params)
}
// 删除task
export const delTask = (params) => {
  return request.post(`/source/task/delete/${params.id}`)
}
// 执行task
export const executeTask = (params) => {
  return request.post(`/source/task/execute/${params.id}`)
}
// 添加任务
export const sourceTaskAdd = (params) => {
  return request.post(`/source/task/add`, params)
}
// 修改任务
export const sourceTaskUpd = (params) => {
  return request.post(`/source/task/upd`, params)
}
// 生成task合集及taskBase
export const taskBaseGenerate = (params) => {
  return request.post(`/task_base/generate`, params)
}
// 查看task-base下的taskList
export const base_taskList = (params) => {
  return request.post(`/source/task/detail/${params.id}`)
}

// 知识列表
export const queryKnowledge = (params) => {
  return request.post(`/course/page`, params)
}
// 文件列表
export const queryFileList = (params) => {
  return request.post(`/knowdoc/page`, params)
}
// 课程del
export const knowledgeDel = (params) => {
  return request.post(`/course/delete/${params.id}`)
}
// 删除知识文档
export const knowdocDelete = (params) => {
  return request.post(`/knowdoc/delete/${params.id}`)
}
